import React from 'react'
import { TileRoleRoute } from '@/types'
import { faChartLine } from '@fortawesome/free-solid-svg-icons'
import { Roles } from '@/auth/azure/Roles'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'
import { AnalysisPageRoute } from '@/routes/analysis/AnalysisPage.route'

export const AnalysisRoute: TileRoleRoute = {
  path: 'analysis',
  text: 'Analisi',
  faIcon: faChartLine,
  element: (
    <ManagementGridFactory
      entity="stato_analisi"
      referencesCollection="analisi"
      referencesTitle="Analisi"
      displayField="ded_Dis"
      entityRoute={AnalysisPageRoute.path as string}
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Analisi',
      icon: faChartLine,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
